import React, { useEffect, useState, useContext } from 'react';
import { Col, Flex, Layout, Row } from 'antd';
import OngoingTripsList from './OngoingTripsList';
import BroadcastForm from './BroadcastForm';
import BroadcastStatus from './BroadcastStatus';
import { VEHICLE_STATUS } from '../../../utilities/constants';
import { API } from '../../../services';
import { ErrorMessageContext } from '../../../context/ErrorMessageContext';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { getErrorMessage } from '../../../utilities/commonFunctions';
const { Sider, Content } = Layout;

const BroadcastContent = ({ activeKey, setActiveKey, setLastUpdatedTime }) => {
  const { addErrorMessage } = useContext(ErrorMessageContext);
  const [tripData, setTripData] = useState([]);
  const [selectedTripsCount, setSelectedTripsCount] = useState(
    tripData?.length
  );
  const [broadcastData, setBroadcastData] = useState([]);
  const [initailvehicleCount, setInitailvehicleCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const currentDate = dayjs().format('DD-MM-YYYY');
  let isFetching = false;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    if (isFetching) return;
    isFetching = true;

    let page = 1;
    setLoading(true);
    while (page !== null) {
      try {
        const payload = {
          filter: {
            trip_status: VEHICLE_STATUS.Active,
            'tripId/vehicleNo': '',
            start_date: currentDate,
            end_date: currentDate,
          },
        };
        const { data, status } = await API.getTripReports(
          page,
          20,
          payload,
          false
        );
        if (status === 200) {
          const formattedData = data?.results?.map((trip, index) => ({
            key: `${page}-${index}`,
            trip_id: trip?.notification?.trip_id || '',
            vehicle_number: trip?.notification?.registration || '',
            vendor: trip?.notification?.vendor?.vendorName || '',
            device_id: trip?.notification?.ridebuddy_deviceid || '',
            checked: true,
          }));
          setTripData(prevTripData => [...prevTripData, ...formattedData]);
          page = data?.next_page_number;
        }
      } catch (error) {
        setLoading(false);
        page = null;
        addErrorMessage(
          getErrorMessage(
            error,
            'Unable to fetch trip details! Please try again after sometime.'
          ),
          `${error?.response?.data?.message ? 'info' : 'error'}`
        );
      }
    }
    setLoading(false);
    isFetching = false;
  };

  return (
    <Layout className="full-height">
      <Sider width="max-content">
        <OngoingTripsList
          tripData={tripData}
          setTripData={setTripData}
          selectedTripsCount={selectedTripsCount}
          setSelectedTripsCount={setSelectedTripsCount}
          loading={loading}
        />
      </Sider>
      <Content className="content-broadcast">
        <Flex gap={10} vertical className="full-height">
          <Row gutter={10} className="content-body">
            <Col
              sm={{ span: 24 }}
              // lg={{ span: 14 }}
              xl={{ span: 16 }}
              className="full-height"
            >
              <BroadcastForm
                selectedRecipients={tripData
                  ?.filter(value => value?.checked)
                  ?.map(value => ({
                    device_id: value?.device_id,
                    vehicle_number: value?.vehicle_number,
                    key: value?.key,
                    trip_id: value?.trip_id,
                  }))}
                tripData={tripData}
                setTripData={setTripData}
                selectedTripsCount={selectedTripsCount}
                setBroadcastData={setBroadcastData}
                setInitailvehicleCount={setInitailvehicleCount}
              />
            </Col>
            <Col
              sm={{ span: 24 }}
              // lg={{ span: 10 }}
              xl={{ span: 8 }}
              className="full-height"
            >
              <BroadcastStatus
                activeKey={activeKey}
                setActiveKey={setActiveKey}
                broadcastData={broadcastData}
                setBroadcastData={setBroadcastData}
                initailvehicleCount={initailvehicleCount}
                setLastUpdatedTime={setLastUpdatedTime}
              />
            </Col>
          </Row>
        </Flex>
      </Content>
    </Layout>
  );
};

BroadcastContent.propTypes = {
  activeKey: PropTypes.string,
  setActiveKey: PropTypes.func.isRequired,
  setLastUpdatedTime: PropTypes.func.isRequired,
};

export default React.memo(BroadcastContent);
